import { WaitingOnYouFilterV2, WaitingOnYouRowsResponseV2 } from '../types';

import {
  WAITING_ON_YOU_MOCK_PAGE_SIZE,
  WAITING_ON_YOU_ROWS_MOCK_V2,
} from './waiting-on-you.mock';

/**
 * Pages the V2 Waiting on you mock by filter, mimicking the paginated API.
 *
 * `count` is the filtered total and `counts` stays unfiltered; a page past the
 * data returns empty `items`, and a page below 1 clamps to the first.
 *
 * @param filter - Tab whose rows are paged.
 * @param page - 1-based page number.
 * @param pageSize - Rows per page.
 * @param source - Payload to page (injectable for tests).
 */
export function paginateWaitingOnYouMockV2(
  filter: WaitingOnYouFilterV2,
  page = 1,
  pageSize = WAITING_ON_YOU_MOCK_PAGE_SIZE,
  source: WaitingOnYouRowsResponseV2 = WAITING_ON_YOU_ROWS_MOCK_V2,
): WaitingOnYouRowsResponseV2 {
  const _page = Math.max(1, Math.trunc(page));
  const _size = Math.max(1, Math.trunc(pageSize));
  const _filtered =
    filter === 'all'
      ? source.items
      : source.items.filter((item) => item.entity_type === filter);
  const _start = (_page - 1) * _size;

  return {
    count: _filtered.length,
    counts: source.counts,
    items: _filtered.slice(_start, _start + _size),
    total_pages: Math.ceil(_filtered.length / _size),
  };
}
